import axios from '@_system/axios/axios.js'
export default {
	path: '/crmcustomerwecom',
	copyBycode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/copyBycode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/crmcustomer.crmcustomerwecom', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},

	

	listgoods(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/listgoods', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delgoods(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/delgoods', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	updategoods(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/updategoods', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	pullgoods(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/pullgoods', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
